<script>
    export default {
        props: {
            visible: {
                type: Boolean,
                default: true,
                required: false
            },
            text: {
                type: String,
                default: '',
                required: false
            }
        },
        name: 'loading'
    };
</script>
<template>
    <transition name="fade">
        <div class="loading-mask" v-show="visible">
            <div class="loading-spinner">
                <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none"/>
                </svg>
                <p v-if="text" class="loading-text" v-html="text"></p>
            </div>
        </div>
    </transition>
</template>
<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    .loading-spinner {
        top: 50%;
        margin-top: -23px;
        width: 100%;
        text-align: center;
        position: absolute;

        .circular {
            margin: 0;
            height: 42px;
            width: 42px;
            animation: loading-rotate 2s linear infinite;
        }

        .path {
            animation: loading-dash 1.5s ease-in-out infinite;
            stroke-dasharray: 90, 150;
            stroke-dashoffset: 0;
            stroke-width: 2;
            stroke: @primaryBg;
            stroke-linecap: round;
        }

        .loading-text {
            color: @primaryBg;
            margin: 3px 0;
            line-height: 1.5;
            font-size: 14px;
        }
    }

    @keyframes loading-rotate {
        to {
            transform: rotate(1turn)
        }
    }

    @keyframes loading-dash {
        0% {
            stroke-dasharray: 1, 200;
            stroke-dashoffset: 0
        }
        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -40px
        }
        to {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -120px
        }
    }

</style>
